import { LogLevel } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_AZ_TENANT_ID;
const clientId = process.env.REACT_APP_AZ_CLIENT_ID;
const env = process.env.REACT_APP_ENV || "PROD";

if (!tenantId) {
  throw new Error("REACT_APP_AZ_TENANT_ID is not defined in the environment variables.");
}

if (!clientId) {
  throw new Error("REACT_APP_AZ_CLIENT_ID is not defined in the environment variables.");
}

// const browserCheck = () => {
//   const getPlatform = () => navigator?.userAgentData?.platform || navigator?.platform || "";
//   const isMacBook = (platform) => /macintosh|macintel|macos/.test(platform.toLowerCase()) && navigator.maxTouchPoints === 0;
//   const isIOS = (platform) => /ipad|iphone|ipod/.test(platform.toLowerCase()) || isMacBook(getPlatform());

//   // try {
//   //   if (navigator.userAgentData) {
//   //     const brands = await navigator.userAgentData.getHighEntropyValues(["brands", "model", "platform", "platformVersion"]);
//   //     const brandNames = brands.brands.map((b) => b.brand.toLowerCase());
//   //     const isChromeIOS = brandNames.some((b) => b.includes("crios"));
//   //     const isSafari = brandNames.some((b) => b.includes("safari")) && !brandNames.some((b) => b.includes("chromium"));

//   //     return isIOS(getPlatform()) && (isChromeIOS || isSafari);
//   //   }
//   // } catch (error) {
//   //   console.warn("Modern browser detection failed:", error);
//   // }

//   const ua = navigator.userAgent.toLowerCase();
//   const isChromeIOS = /crios/.test(ua);
//   const isSafari = /safari/.test(ua) && !/chrome|chromium/.test(ua);
//   // const isEdge = /edg/.test(ua);

//   return isIOS(getPlatform()) && (isChromeIOS || isSafari);
// };

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    // postLogoutRedirectUri: `${window.location.origin}/sign-in`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: env === "DEV" || env === "UAT" ? LogLevel.Info : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        switch (level) {
          case LogLevel.Error:
            console.error(`MSAL Error: ${message}`);
            break;
          case LogLevel.Warning:
            if (env === "DEV" || env === "UAT") {
              console.warn(`MSAL Warning: ${message}`);
            }
            break;
          case LogLevel.Info:
            if (env === "DEV" || env === "UAT") {
              console.info(`MSAL Info: ${message}`);
            }
            break;
          default:
            break;
        }
      },
    },
  },
};

// "User.Read"
export const loginRequest = {
  // scopes: ["openid", "profile"],
  scopes: [],
};
